import { render, staticRenderFns } from "./BlankTest.vue?vue&type=template&id=5dd06260&scoped=true"
import script from "./BlankTest.vue?vue&type=script&lang=js"
export * from "./BlankTest.vue?vue&type=script&lang=js"
import style0 from "./BlankTest.vue?vue&type=style&index=0&id=5dd06260&prod&lang=less"
import style1 from "./BlankTest.vue?vue&type=style&index=1&id=5dd06260&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd06260",
  null
  
)

export default component.exports